// Documents vivants de la conversation (backend/documents/edition.js) : versions déduites des
// messages, comme la carte live. Module pur, sans React.

export const panneauDocument = (documentId) => `document-live:${documentId}`;

/** Versions de chaque document : Map(document_id → [{version, spec, artifactId, messageId}]), dans l'ordre. */
export function versionsDesDocuments(messages) {
  const out = new Map();
  for (const message of messages ?? []) {
    for (const artifact of message.artifacts ?? []) {
      const id = artifact?.spec?.document_id;
      if (artifact.status !== 'ready' || typeof id !== 'string' || !id) continue;
      const liste = out.get(id) ?? [];
      const version = Number(artifact.spec.document_version) || 1;
      const entree = { version, spec: artifact.spec, artifactId: artifact.id, messageId: message.id };
      const deja = liste.findIndex((v) => v.version === version);
      if (deja >= 0) liste[deja] = entree;
      else liste.push(entree);
      out.set(id, liste);
    }
  }
  for (const liste of out.values()) liste.sort((a, b) => a.version - b.version);
  return out;
}

/** Une modification de document est-elle en préparation dans la réponse en cours ? */
export function modificationEnCours(messages) {
  const dernier = messages?.at?.(-1);
  return Boolean(dernier?.artifacts?.some((a) => a.status === 'pending' && a.modification === true));
}
